import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CryptoJS from 'crypto-js';
import { endpoints } from 'Core/defaultValues';
//Actions
import { getAccessEldApollo } from 'Redux/actions'

const ELDView = () => {
  const dispatch = useDispatch();

  const { user, accessEldApollo, loadingAccessEldApollo } = useSelector((state) => state.securityRedux);

  useEffect(() => {
    if (user?.eldUser && user?.eldUser?.username && user?.eldUser?.password) {
      let currentEldPassword = CryptoJS.AES.decrypt(user?.eldUser?.password, 'gpstrackit');
      let originalPassword = currentEldPassword?.toString(CryptoJS.enc.Utf8) || user?.eldUser?.password
      dispatch(getAccessEldApollo({ username: user.eldUser.username, password: originalPassword }))
    }
  }, [user])
  

  return (
    <div style={{ height: '95vh' }}>
      {
        !loadingAccessEldApollo &&
        <iframe
          id="apollo-eld-portal"
          title="Apollo Eld Portal"
          width="100%"
          height="100%"
          src={!user?.eldUser?.username ? `${endpoints.APOLLO_URL}` : `${endpoints.APOLLO_URL}/userlogin?${accessEldApollo}`}
        >
        </iframe>
      }
    </div>
  )
}

export default ELDView